import React, { useEffect, useState } from "react";
import { Grid, Button, Checkbox } from "@material-ui/core";
import Add from "@material-ui/icons/Add";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import './RequestTypeDetails.css';

const RequestTypeDetails = ({
  handleClose,
  handleSave,
  show,
  isEdit,
  data,
  handleValidation
}) => {

  const defaultData = {
    requestType: null,
    requestTypeName: "",
    active: true,
  };
  const errorData = {
    // Error fields
    requestTypeNameErr: "",
  };
  const [errorFields, setErrorFields] = useState({ ...errorData });
  const [formData, setFormData] = useState({ ...defaultData });

  useEffect(() => {
    if (isEdit) {
      getRequestTypeDetails();
    } else {
      setFormData({ ...defaultData });
    }
    setErrorFields({ ...errorData });
  }, [show]);

  const getRequestTypeDetails = () => {
    setFormData({ ...formData, ...data });
  };

  const handleSubmit = async () => {
    let {user} = JSON.parse(sessionStorage.getItem("passData"));
    let errorFieldsData = { ...errorData };
    let validationError = false;
    if (!handleValidation(formData, errorFieldsData)) {
      validationError = true;
    }
    if (!formData.requestTypeName) {
      errorFieldsData.requestTypeNameErr = "This field is required";
      validationError = true;
    }
    setFormData({ ...formData });
    setErrorFields({ ...errorFieldsData });
    if (validationError) {
      return;
    }
    if (!formData.createdBy) {
      formData.createdBy = user;
    }
    console.log("handleSubmit", isEdit, formData)
    if (isEdit) {
      await axios.post(
        `${global.REACT_APP_API_ENDPOINT}/requestType/updateRequestType`, { ...formData, updatedBy: user });
      handleSave();
    } else {
      await axios.post(
        `${global.REACT_APP_API_ENDPOINT}/requestType/saveRequestType`, { ...formData, updatedBy: user });
      handleSave();
    }
  };

  const handleChange = (event) => {
    if (event.target.value == "") {
      errorFields[event.target.name + "Err"] = "This field is required"
    }
     else {
      errorFields[event.target.name + "Err"] = "";
    }
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
    setErrorFields({
      ...errorFields,
    })
  };

  return (
    <Modal
      show={show}
      size="md"
      backdrop="static"
      style={{
        background: "rgba(0, 0, 0, 0.5)",
      }}
      onHide={handleClose}
    >
      <Modal.Header className="the-modal-header" closeButton>
        {!isEdit ? (<Add
          style={{
            color: "#000000",
            marginRight: "5px",
            height: "25px",
            width: "25px",
          }}
        />) : (<></>)}
        <Modal.Title className="the-modal-title">
          {isEdit ? "Update Request Type" : "Add Request Type"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="request-modal-body">
        <Grid container spacing={2}>
          <Grid item container spacing={2} xs={12} sm={12} md={12} className="request-input-group">
            <Grid item xs={12} sm={12} md={12}>
              <div>Request Name*</div>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <input
                type="text"
                id="requestTypeName"
                name="requestTypeName"
                className="form-control"
                value={formData.requestTypeName}
                disabled={isEdit}
                onChange={(event) => {
                  handleChange(event);
                }}
              />
              {errorFields.requestTypeNameErr != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorFields.requestTypeNameErr}</p>
              ) : <></>}
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={6} className="request-input-group">
            <Grid item xs={6} sm={6} md={6}>
              <div>Is Active</div>
              <Checkbox checked={formData.active} color="primary" style={{
                color: "#1176B5"
              }} onChange={(event) => {
                formData.active = event.target.checked;
                setFormData({ ...formData });
              }} />
            </Grid>
          </Grid>
        </Grid>
      </Modal.Body>
      <Modal.Footer className="the-modal-footer">
        <Button variant="contained" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" style={{
          backgroundColor: "rgb(17, 118, 181)",
          textTransform: "none"
        }}
          color="primary" onClick={handleSubmit}>
          {isEdit ? "Update" : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RequestTypeDetails;
